import { Trans } from 'react-i18next';
import { MoreButtonIntent } from '@todcode/components/src/component/MoreButtonIntent';
import { formatDateTime } from '@todcode/components';

export const historyParams = [
  {
    param: 'action',
    label: <Trans i18nKey="historyTableHeads.actions" />,
    mix: {
      align: 'center',
    },
  },
  {
    param: 'lenderName',
    label: <Trans i18nKey="historyTableHeads.lender" />,
  },
  {
    param: 'amount',
    label: <Trans i18nKey="historyTableHeads.amount" />,
  },
  {
    param: 'dateTime',
    label: <Trans i18nKey="historyTableHeads.dateTime" />,
    transform: formatDateTime,
  },
  {
    label: <Trans i18nKey="historyTableHeads.actions" />,
    align: 'center',
    buttons: [
      {
        Button: MoreButtonIntent,
        action: 'moreInfo',
        isActive: (item) => item.transaction || item.intent,
      },
    ],
  },
];
